import React from 'react';
import Intro from './components/intro';
import Categories from './components/categories';
import ProductList from './components/product-list';
import Cart from './components/cart';

const baseCart = {
	'canasta-basica': { category: 'Canasta básica', items: {} },
	'spa': { category: 'Servicios públicos y alquileres', items: {} },
	'edu-salud': { category: 'Educación y salud', items: {} },
	'entretenimiento': { category: 'Entretenimiento', items: {} },
	'renta': { category: 'Renta', items: {} },
}

class App extends React.Component {

	state = {
		cart: baseCart,
		items: [],
		currentCategory: 'canasta-basica',
		itemList: []
	};

	updateCurrentCategory = (cat) => {
		this.setState({ currentCategory: cat });
	}

	initItemList = (cat, categoryName = '') => {
		var category = '';
		var cartItems = [];
		
		if ( categoryName === 'renta' ) {
			category = categoryName;
			cartItems = cat;
		} else {
			category = cat.category;
			cartItems = cat.items;
		}

		var itemList = { ...this.state.itemList };
		if( itemList[`${category}-item-0`] === undefined ) {
			// No hay elementos seteados, procedemos a darles un valor por default
			cartItems.map( (prod, idx) => itemList[`${category}-item-${idx}`] = { value: '', cart: false } );
			this.setState({ itemList });
		}
	}

	udpateItemsList = items => {
		this.setState({ items });
	}

	updateItemListPrices = (item, value) => {
		var itemList = { ...this.state.itemList };
		itemList[item].value = value;
		this.setState({ itemList });

		// Si el producto está en el carrito, actualizamos su valor
		if( itemList[item].cart ) { this.updateCart(item) }
	}

	addToCart = (product, key, cart) => {
		// Agregamos la variable en itemList
		var stateCart = { ...this.state.cart };
		var itemList = { ...this.state.itemList };

		itemList[key].cart = true;

		//Agregamos el producto al carrito, aplicando el impuesto respectivo
		var prod = {
			name: product.item,
			newValue: this.getPrice(product, key),
			oldValue: parseInt( itemList[key].value, 10 ),
			newTax: product.newTax,
			prevTax: product.prevTax
		}

		if( product.rangos !== undefined ) {
			prod.name = "Salario";
			prod.prevValue = this.getRent(product.rangosPrev, prod.oldValue);
			prod.diff = this.getDiff(prod.newValue, prod.prevValue);
			prod.rangos = product.rangos;
			prod.rangosPrev = product.rangosPrev;
		} else if(product.limits !== undefined) {
			prod.limits = product.limits;
			prod.diff = this.getDiff(prod.newValue, prod.oldValue);
		} else {
			prod.diff = this.getDiff(prod.newValue, prod.oldValue);
		}

		stateCart[this.state.currentCategory].items[key] = prod;

		this.setState({ cart: stateCart, itemList: itemList });
	}

	deleteFromCart = (category, key) => {
		var stateCart = { ...this.state.cart };
		var itemList = { ...this.state.itemList };

		itemList[key].cart = false;
		delete stateCart[category].items[key];

		this.setState({ cart:stateCart, itemList: itemList });
	}

	updateCart = (key) => {
		var stateCart = { ...this.state.cart };
		var itemList = { ...this.state.itemList };
		var prod = stateCart[this.state.currentCategory].items[key];

		if( stateCart[this.state.currentCategory].items[key].prevValue !== undefined ) {
			stateCart[this.state.currentCategory].items[key].prevValue = this.getRent(prod.rangosPrev, itemList[key].value);
			stateCart[this.state.currentCategory].items[key].oldValue = itemList[key].value;
			stateCart[this.state.currentCategory].items[key].diff = this.getDiff(prod.newValue, prod.prevValue);
		} else {
			stateCart[this.state.currentCategory].items[key].newValue = this.getPrice(prod, key);
			stateCart[this.state.currentCategory].items[key].oldValue = itemList[key].value;
			stateCart[this.state.currentCategory].items[key].diff = this.getDiff(prod.newValue, prod.oldValue);
		}

		this.setState({ cart: stateCart });
	}

	getPrice(product, key) {
		var itemList = { ...this.state.itemList };
		var price = parseInt(itemList[key].value, 10);

		if( product.rangos !== undefined ) {
			// Calculamos la renta
			price = this.getRent(product.rangos, price);
		} else if( product.limits !== undefined ) {
			//Calculamos la electricidad
			price = this.getElectricity(product.limits, price)
		} else {
			if( product.newTax > 0 && product.newTax > product.prevTax ) {

				if( product.base !== undefined && product.base != '' ) {
					if ( price > product.base ) {
						price = ( price * product.newTax ) / 100 + price;
					}
				} else {
					price = ( price * product.newTax ) / 100 + price;
				}
			} else if(product.prevTax > product.newTax && product.newTax == 0) {
				price = price - ( price * product.prevTax ) / 100;
			}
		}
		
		return Math.round(price);
	}

	getRent(rangos, salario) {
		var renta = 0;
		
		rangos.map( (rango, idx) => {
			let diff = 0;
			if( rango.min <= salario ) {
				if( salario < rango.max ) {
					if( rango.tax > 0 ) {
						diff = salario - rango.min;
					}
				} else {
					if( rango.max > 0 ) {
						diff = rango.max - rango.min;
					} else {
						diff = salario - rango.min;
					}
				}
				if( diff > 0 && rango.tax > 0 ) {
					let excedente = (diff * rango.tax /100);
					renta = renta + excedente;
				}
			}
		})

		return Math.round(renta);
	}
	
	getElectricity(rangos, price) {
		var localPrice = price;
		
		rangos.map( item => {
			if( price > item.min && price <= item.max ) {
				if( item.tax !== 0 ) {
					if( item.tax < 0 ) {
						//restamos el porcentaje
						localPrice = price - ( price * Math.abs(item.tax) ) / 100
					} else {
						localPrice = price + ( price * Math.abs(item.tax) ) / 100
					}
				}
			} else if( item.max == 0 && price > item.min ) {
				localPrice = price + ( price * Math.abs(item.tax) ) / 100
			}
		});

		return localPrice;
	}

	getDiff(newValue, oldValue) {
		return Math.round(newValue - oldValue);
	}

	reset = () => {
		var cart = this.getBaseCart();

		this.setState({
				cart: cart,
				items: [],
				itemList: []
			})
	}

	getBaseCart() {
		return {
			'canasta-basica': { category: 'Canasta básica', items: {} },
			'spa': { category: 'Servicios públicos y alquileres', items: {} },
			'edu-salud': { category: 'Educación y salud', items: {} },
			'entretenimiento': { category: 'Entretenimiento', items: {} },
			'renta': { category: 'Renta', items: {} },
		};
	}

	render() {
		return  <article>
					<div className="content">
						<Intro />
						<Categories
							currentCategory={this.state.currentCategory}
							updateCurrentCategory={this.updateCurrentCategory}
							initItemList={this.initItemList}
							udpateItemsList={this.udpateItemsList}
							/>
						<ProductList
							category={this.state.currentCategory}
							products={this.state.items}
							itemList={this.state.itemList}
							addToCart={this.addToCart}
							deleteFromCart={this.deleteFromCart}
							updateItemListPrices={this.updateItemListPrices}
							/>
						<Cart
							cart={this.state.cart}
							deleteFromCart={this.deleteFromCart}
							reset={this.reset}
							/>
					</div>
				</article>
	}

}

export default App;
